import React, { useState } from "react";

import { Table } from "antd";
import ResizableTitle from "./resizable";

/**
 *  Deberíamos usar props types, todos los parametros que se utilizan estan
 * decostruidos en la primera linea.
 */
const Template = (props) => {
    const { data, meta, loading, cols, setCols, handleTableChange, resize, onResize, expandable, rowSelection } = props;
    const size = "small"; // Se podria tomar de los props para que el usuarios lo modifique

    const total = !loading && meta ? meta.total : 0;

    const pagination = {
        current: meta.current ? meta.current : "1",
        pageSize: meta.pageSize ? meta.pageSize : "20",
        total: meta.total ? meta.total : "0",
    };

    const rowKey = (row) => row.id;

    const components = {
        header: {
            cell: ResizableTitle,
        },
    };

    const rcolumns = cols.map((col, index) => {
        if (col["allowResize"]) {
            return {
                ...col,
                onHeaderCell: (column) => ({
                    width: column.width,
                    onResize: onResize(col.key, index),
                }),
            };
        }

        return col;
    });

    const visible = (resize ? rcolumns : cols).filter((item) => item.visible);

    return (
        <Table
            bordered={true}
            expandable={expandable}
            rowSelection={rowSelection}
            size={size}
            components={resize && components}
            rowKey={rowKey}
            dataSource={data}
            columns={visible}
            loading={loading}
            pagination={pagination}
            onChange={handleTableChange}
        />
    );
};

export default Template;
